export default __webpack_public_path__ + "static/banner_background_ny-454cedb3771d9da160f224ffbc289aeb.png";